import { useEffect } from 'react';
import { Storage } from '../../constants/storage';

export function useSidebarPersistence({ isSidebarOpen, isMobile }) {
    useEffect(() => {
        if (isMobile) return;
        try {
            localStorage.setItem(Storage.sidebar_is_open, JSON.stringify(isSidebarOpen));
        } catch (error) {
            console.warn('Could not save sidebar state to localStorage:', error);
        }
    }, [isSidebarOpen, isMobile]);
}
